import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Bugsnag from "@/lib/bugsnag";

const NotFound = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    Bugsnag.notify(
      new Error(`Redirecting from non-existent route: ${location.pathname}`),
      (event) => {
        event.severity = "info";
        event.context = "routing";
      }
    );
    navigate("/" + location.search, { replace: true });
  }, [navigate, location.pathname, location.search]);

  return null;
};

export default NotFound;
